export default {
  'delegations.title': 'Gestionar Delegaciones',

  'delegations.form.id': 'ID',
  'delegations.form.status': 'Estado',
  'delegations.form.type': 'Tipo',
  'delegations.form.delegationNumber': 'Nro Delegación',
  'delegations.form.startDate': 'Inicio',
  'delegations.form.startDateMinLead':
    'La fecha y hora de inicio debe ser al menos {minutes} minutos posterior a la hora actual.',
  'delegations.form.endDate': 'Fin',
  'delegations.form.endDateAfterStart': 'La fecha de fin debe ser posterior a la fecha de inicio.',
  'delegations.form.approver': 'Usuario Aprobador',
  'delegations.form.sourceUserHint': 'El usuario que estará ausente al que vas a delegar',
  'delegations.form.reason': 'Motivo',
  'delegations.form.delegatePendingTasks': '¿Delegar Tareas Pendientes?',
  'delegations.form.keepSourceUserAsApproval': '¿Mantener Usuario Aprobador?',
  'delegations.form.removeDelegatedTasksAtTheEnd':
    '¿Remover Tareas Delegadas al Finalizar Delegación?',
  'delegations.form.voidedReason': 'Motivo de Anulación',
  'delegations.form.voidedDate': 'Fecha de Anulación',
  'delegations.form.voidedUser': 'Anulado Por',

  'delegations.delegationType.temporary': 'Temporal',
  'delegations.delegationType.definitive': 'Definitiva',

  'delegations.delegationStatus.pending': 'Pendiente',
  'delegations.delegationStatus.execution': 'En ejecución',
  'delegations.delegationStatus.finished': 'Finalizado',
  'delegations.delegationStatus.voided': 'Anulado',
  'delegations.delegationStatus.error': 'Error',
  'delegations.delegationStatus.modal.cancel.title': 'Motivo de Anulación',
  'delegations.delegatedTasks': 'Tareas Delegadas',
};
